import { render } from "./InputPassword.vue?vue&type=template&id=65af53ea"
import script from "./InputPassword.vue?vue&type=script&lang=js"
export * from "./InputPassword.vue?vue&type=script&lang=js"

import exportComponent from "D:\\WEB\\LICEO\\CURSOS\\portalalumnoscursos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__